import { render } from "./hero.vue?vue&type=template&id=169b7a47&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=169b7a47&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-169b7a47"

export default script